import { atom, selectorFamily } from 'recoil';

export const userConnectionState = atom({
	key: 'userConnectionAtomKey',
	default: [] as string[],
	dangerouslyAllowMutability: true,
});

export const sessionConnectionStatusForUser = selectorFamily({
	key: 'sessionConnectionStatusForUserKey',
	get:
		(userId: string) =>
		({ get }) => {
			const connections = get(userConnectionState);
			return connections.includes(userId);
		},
	cachePolicy_UNSTABLE: {
		eviction: 'most-recent',
	},
});
